import { ComponentRegistry } from "@enonic/react-components";

import { defaultPage } from "./components/pages/defaultPage/defaultPage";
import { omsorgPage } from "./components/pages/omsorgPage/omsorgPage";

import { ArticleBodyLayout } from "./components/layouts/articleBodyLayout/articleBodyLayout";
import { NewsArticleBodyLayout } from "./components/layouts/newsArticleBodyLayout/newsArticleBodyLayout";
import { OneColumnLayout } from "./components/layouts/oneColumn/oneColumn";
import { TwoColumnsLayout } from "./components/layouts/twoColumns/twoColumns";
import { ThreeColumnLayout } from "./components/layouts/threeColumn/threeColumn";

import { AccordionPart } from "./components/parts/Accordion/Accordion";
import { ActionCardPart } from "./components/parts/ActionCard/ActionCard";
import { AuthorPublishDatePart } from "./components/parts/AuthorPublishDate/AuthorPublishDate";
import { BaseContentPart } from "./components/parts/BaseContent/BaseContent";
import { ButtonPart } from "./components/parts/Button/Button";
import { EmployeeCardPart } from "./components/parts/EmployeeCard/EmployeeCard";
import { EmployeeCardListPart } from "./components/parts/EmployeeCardList/EmployeeCardList";
import { EventDetailsPart } from "./components/parts/EventDetails/EventDetails";
import { EventsPart } from "./components/parts/Events/Events";
import { FactBoxPart } from "./components/parts/FactBox/FactBox";
import { FocusAreasPart } from "./components/parts/FocusAreas/FocusAreas";
import { GrayFactBoxPart } from "./components/parts/GrayFactBox/GrayFactBox";
import { ListPagesPart } from "./components/parts/ListPages/ListPages";
import { NewsPart } from "./components/parts/News/News";
import { PublishDatePart } from "./components/parts/PublishDate/PublishDate";
import { QuotePart } from "./components/parts/Quote/Quote";
import { SearchPart } from "./components/parts/Search/Search";
import { SectionMenuPart } from "./components/parts/SectionMenu/SectionMenu";
import { SectionMenu2Part } from "./components/parts/SectionMenu2/SectionMenu2";
import { SubPageHeaderPart } from "./components/parts/SubPageHeader/SubPageHeader";
import { TitlePart } from "./components/parts/Title/Title";
import { TopImagePart } from "./components/parts/TopImage/TopImage";
import HeroPart from "./components/parts/HeroSection/Hero";
import StatsPart from "./components/parts/Stats/Stats";
import MacroPart from "./components/parts/Macro/Macro";
import TimelinePart from "./components/parts/Timeline/Timeline";
import TextContainerPart from "./components/parts/TextContainer/TextContainer";
import ServicesSectionPart from "./components/parts/ServicesSection/ServicesSection";
import FormViewPart from "./components/parts/FormView/FormView";
import YogoWidgetPart from "./components/parts/YogoWidget/YogoWidget";
import EmbedMacro from "./components/macros/Embed/Embed";

export const componentRegistry = new ComponentRegistry();

componentRegistry.addPage("diakonhjemmet:default", { View: defaultPage });
componentRegistry.addPage("diakonhjemmet:omsorg", { View: omsorgPage });

componentRegistry.addLayout("diakonhjemmet:articleBodyLayout", {
  View: ArticleBodyLayout,
});
componentRegistry.addLayout("diakonhjemmet:newsArticleBodyLayout", {
  View: NewsArticleBodyLayout,
});
componentRegistry.addLayout("diakonhjemmet:oneColumn", {
  View: OneColumnLayout,
});
componentRegistry.addLayout("diakonhjemmet:twoColumns", {
  View: TwoColumnsLayout,
});
componentRegistry.addLayout("diakonhjemmet:threeColumn", {
  View: ThreeColumnLayout,
});

componentRegistry.addPart("diakonhjemmet:accordion", { View: AccordionPart });
componentRegistry.addPart("diakonhjemmet:action-card", {
  View: ActionCardPart,
});
componentRegistry.addPart("diakonhjemmet:author-publish-date", {
  View: AuthorPublishDatePart,
});
componentRegistry.addPart("diakonhjemmet:base-content", {
  View: BaseContentPart,
});
componentRegistry.addPart("diakonhjemmet:button", {
  View: ButtonPart,
});
componentRegistry.addPart("diakonhjemmet:employee-card", {
  View: EmployeeCardPart,
});
componentRegistry.addPart("diakonhjemmet:employee-card-list", {
  View: EmployeeCardListPart,
});
componentRegistry.addPart("diakonhjemmet:event-details", {
  View: EventDetailsPart,
});
componentRegistry.addPart("diakonhjemmet:events", {
  View: EventsPart,
});
componentRegistry.addPart("diakonhjemmet:fact-box", {
  View: FactBoxPart,
});
componentRegistry.addPart("diakonhjemmet:focus-areas", {
  View: FocusAreasPart,
});
componentRegistry.addPart("diakonhjemmet:gray-fact-box", {
  View: GrayFactBoxPart,
});
componentRegistry.addPart("diakonhjemmet:hero-section", {
  View: HeroPart,
});
componentRegistry.addPart("diakonhjemmet:list-pages", {
  View: ListPagesPart,
});
componentRegistry.addPart("diakonhjemmet:macro", {
  View: MacroPart,
});
componentRegistry.addPart("diakonhjemmet:news", {
  View: NewsPart,
});
componentRegistry.addPart("diakonhjemmet:publish-date", {
  View: PublishDatePart,
});
componentRegistry.addPart("diakonhjemmet:quote", {
  View: QuotePart,
});
componentRegistry.addPart("diakonhjemmet:search", {
  View: SearchPart,
});
componentRegistry.addPart("diakonhjemmet:section-menu", {
  View: SectionMenuPart,
});
componentRegistry.addPart("diakonhjemmet:section-menu2", {
  View: SectionMenu2Part,
});
componentRegistry.addPart("diakonhjemmet:services-section", {
  View: ServicesSectionPart,
});
componentRegistry.addPart("diakonhjemmet:sub-page-header", {
  View: SubPageHeaderPart,
});
// Third-party: Enonic Form Builder app
componentRegistry.addPart("com.enonic.app.formbuilder:form-part", {
  View: FormViewPart,
});

componentRegistry.addPart("diakonhjemmet:stats", {
  View: StatsPart,
});
componentRegistry.addPart("diakonhjemmet:text-container", {
  View: TextContainerPart,
});
componentRegistry.addPart("diakonhjemmet:timeline", {
  View: TimelinePart,
});
componentRegistry.addPart("diakonhjemmet:title", {
  View: TitlePart,
});
componentRegistry.addPart("diakonhjemmet:top-image", {
  View: TopImagePart,
});
componentRegistry.addPart("diakonhjemmet:yogo-widget", {
  View: YogoWidgetPart,
});

componentRegistry.addMacro("embed", { View: EmbedMacro });
